import React from 'react';
import MuiRadio, { RadioProps as MuiRadioProps } from '@mui/material/Radio';

export type RadioProps = MuiRadioProps;

export const Radio = React.forwardRef<HTMLButtonElement, RadioProps>((props, ref) => {
  return <MuiRadio color='primary' {...props} ref={ref} />;
});
